import { InvestigationsRoutePath } from "#src/routes/investigations";
import { createUuidRoutePathParameter, RoutePath } from "#src/utils/route";

export type InvestigationDetailPageParameters = {
  investigationId: string;
};

export const InvestigationDetailRoutePath = InvestigationsRoutePath.concat(
  new RoutePath<"investigationId">({
    path: `/${createUuidRoutePathParameter("investigationId")}`,
    title: "Investigation Detail",
  })
);
